import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Button } from 'antd';
import clx from 'classnames';
import type React from 'react';
import styled from 'styled-components';
import { hasRichTextAdvanced } from '../../../../../../inputs/rich-text-advanced/hasRichTextAdvanced.ts';
import { type IAdvancedRichText } from '../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { LabelLikeFormItem } from './LabelLikeFormItem.tsx';

export const RepeatableContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  // eliminiamo lo spazio sotto il titolo
  // è duplicato in preview dal container dei widget
  /* padding-bottom: 12px; */
`;
export const RowWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 0;
  border: 1px solid ${props => props.theme.colorBorder};
  border-bottom: none;
  &:first-of-type,
  &.first-element {
    border-radius: ${props => props.theme.borderRadius}px
      ${props => props.theme.borderRadius}px 0 0;
  }
  &:last-child {
    border-radius: ${props => props.theme.borderRadius}px;
    border: 1px solid ${props => props.theme.colorBorder};
  }
  .hide-borders & {
    border-radius: 0;
    border: none;
    padding: 0;
  }
  // Errori
  .ant-form-item-has-error & {
    border-color: ${props => props.theme.colorError};
  }
`;
export const RowLastWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 0 0 ${props => props.theme.borderRadius}px
    ${props => props.theme.borderRadius}px;
  border: 1px solid ${props => props.theme.colorBorder};
  /* border-top: none; */
  &:first-child,
  &.no-list-to-show {
    border-radius: ${props => props.theme.borderRadius}px;
  }
  // Errori
  .ant-form-item-has-error & {
    border-color: ${props => props.theme.colorError};
  }
  .hide-borders & {
    border-radius: 0;
    border: none;
    padding: 0;
  }
`;
export const RowParagraphWrapper = styled.div`
  margin-bottom: 0;
  &&& {
    p {
      margin-bottom: 0;
    }
  }
`;
/* Elemento inserito per allineate gli elementi laterali del Widget al contenuto
da verificare per il render finale del form */
export const AlignItemWrapper = styled.div`
  padding-bottom: 16px;
`;

export interface IRepeatableContainerProps {
  buttonText?: string;
  description?: IAdvancedRichText;
  hideNumberItems?: boolean;
  hideBorder?: boolean;
  hideAddButton?: boolean;
  children?: React.ReactNode;
  label?: IAdvancedRichText;
}
/**
 * Container della Lista ripetibile
 */
export function RepeatableContainer(props: IRepeatableContainerProps) {
  const {
    buttonText,
    description,
    hideNumberItems,
    hideBorder,
    hideAddButton,
    children,
  } = props;

  const showLastRow = !hideAddButton || hasRichTextAdvanced(description);

  return (
    <RepeatableContainerWrapper className={clx({ 'hide-borders': hideBorder })}>
      <LabelLikeFormItem label={props.label} />
      {hideBorder && <VerticalSpace />}
      <RowWrapper className="first-element">
        <FlexRow
          gutter={12}
          left={
            hideNumberItems ? undefined : <AlignItemWrapper>1</AlignItemWrapper>
          }
          right={
            <AlignItemWrapper>
              <Button size="large" disabled icon={<MinusOutlined />} />
            </AlignItemWrapper>
          }
        >
          {children}
        </FlexRow>
      </RowWrapper>
      {showLastRow && (
        <RowLastWrapper>
          <div>
            <FlexRow
              gutter={24}
              align="flex-start"
              right={
                !hideAddButton ? (
                  <Button
                    size="large"
                    icon={<PlusOutlined aria-hidden="true" />}
                  >
                    {buttonText ?? 'Aggiungi'}
                  </Button>
                ) : undefined
              }
            >
              {description && (
                <RowParagraphWrapper>
                  <RichTextAdvancedRender hasCustomFont text={description} />
                </RowParagraphWrapper>
              )}
            </FlexRow>
          </div>
        </RowLastWrapper>
      )}
    </RepeatableContainerWrapper>
  );
}
